import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import {
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/TabPaymentDetailMSMESlice";
import { AppDispatch, RootState } from "src/redux/store";
import { formatDateAndTime } from "src/utils/dateAndTime";
import moment from "moment";
import { MSMEPaymentDetailListResponse } from "src/models/MSMEPaymentDetailResponse.model";
import { useGetMSMEPaymentDetailQuery, useGetMSMEPaymentDetailExportMutation } from "src/services/TabFailedPaymentApplicationService";
import { getColumns } from "src/utils/auth/getColumns";
import TabFailedPaymentMSMEApplicationListing from "./TabPaymentDetailMSMEApplicationListing";

// Params List
const paramList = [
  "srn",
  "uniqueTransactionId",
  "mobileNumber" ,
   "propritorName"
];

const exportDataHeaders = [
  { label: "Date-Time", key: "appliedOnDate" },
  { label: "SRN", key: "srn" },
  { label: "Propritor Name", key: "propritorName" },
  { label: "Order Id", key: "uniqueTransactionId" },
  { label: "Mobile", key: "mobileNumber" },
];

const TabPaymentDetailMSMEApplicationListingWrapper = () => {
  const dispatch = useDispatch<AppDispatch>();
  const msmeState: any = useSelector(
    (state: RootState) => state.TabPaymentDetailMSMESlice
  );
  const {
    items,
    rowsPerPage,
    searchValue,
    page,
    isTableLoading,
    filterBy,
    dateFilter,
  } = msmeState;

  // Fetching Applications
  const { data, isFetching, isLoading } = useGetMSMEPaymentDetailQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: paramList,
    page: page,
    filterBy: filterBy,
    dateFilter: dateFilter,
    orderBy: "appliedOnDate",
    orderByValue: -1,
    isPaginationRequired: true,
  });
  const [msmePaymentDetailsData, setmsmePaymentDetailsData] = useState<any>({})

  const [exportData] = useGetMSMEPaymentDetailExportMutation();
  const [isAllExporting, setIsAllExporting] = useState(false);
  const [isCurrentExporting, setIsCurrentExporting] = useState(false);
  const [dataToExport, setDataToExport] = useState([]);

  // Setting data
  useEffect(() => {
    if (!isFetching && !isLoading) {
      dispatch(setIsTableLoading(false));
      dispatch(setItems(data?.data || []));
      setmsmePaymentDetailsData(data || {})
      dispatch(setTotalItems(data?.totalItem || 0));
    } else {
      dispatch(setIsTableLoading(true));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isFetching, data]);

  const columns: columnTypes[] = [
    {
      field: "appliedOnDate",
      headerName: "Date - Time",
      noAuthRequired: true,
      flex: "flex-[1_1_0%]",
      renderCell: (row: MSMEPaymentDetailListResponse) => (
        <div>
          <div className="text-slate-700 font-medium">
            {formatDateAndTime(row.appliedOnDate, "DD MMM yyyy")}
          </div>
          <div className="text-[13px] font-medium text-slate-400">
            {formatDateAndTime(row.appliedOnDate, "hh:mm A")}
          </div>
        </div>
      ),
    },
    {
      field: "srn",
      headerName: "SRN",
      flex: "flex-[1.3_1.3_0%]",
      renderCell: (row: MSMEPaymentDetailListResponse) => {
        return (
          <span className="text-primary-main text-[13px] text-ellipsis overflow-hidden">
            {row.srn}
          </span>
        );
      },
    },
    {
      field: "propritorName",
      headerName: "Proprietor Name",
      flex: "flex-[1_1_0%]",
      renderCell: (row: MSMEPaymentDetailListResponse) => (
        <span> {row.propritorName} </span>
      ),
    },
    {
      field: "uniqueTransactionId",
      headerName: "Order Id",
      flex: "flex-[1.4_1.4_0%]",
      renderCell: (row: MSMEPaymentDetailListResponse) => {
        return (
          <span className="text-ellipsis overflow-hidden"> {row.uniqueTransactionId} </span>
        );
      },
    },
    {
      field: "mobileNumber",
      headerName: "Mobile",
      flex: "flex-[1_1_0%]",
      renderCell: (row: MSMEPaymentDetailListResponse) => {
        return <span> {row.mobileNumber} </span>;
      },
    }
  ];

  // Handle Export
  const handleExport = (done: () => void, isAllExport: boolean) => {
    isAllExport ? setIsAllExporting(true) : setIsCurrentExporting(true);
    exportData({
      limit: rowsPerPage,
      searchValue: searchValue,
      params: paramList,
      page: page,
      filterBy: filterBy,
      dateFilter: dateFilter,
      orderBy: "appliedOnDate",
      orderByValue: -1,
      isPaginationRequired: !isAllExport,
    }).then((res: any) => {
      let formattedData = res?.data?.data?.map((data: any) => {
        return {
          ...data,
          createdAt: moment(data?.appliedOnDate).format("DD-MM-yyyy hh:mm A"),
        };
      });
      setDataToExport(formattedData);
      setTimeout(() => {
        done();
        isAllExport ? setIsAllExporting(false) : setIsCurrentExporting(false);
        document.body.click();
      }, 800);
    });
  };
  return (
    <>
      <TabFailedPaymentMSMEApplicationListing
        columns={getColumns(columns, "MSME_APPLICATIONS")}
        rows={items}
        onExport={handleExport}
        isAllExporting={isAllExporting}
        isCurrentExporting={isCurrentExporting}
        isTableLoading={isTableLoading}
        exportDataHeaders={exportDataHeaders}
        exportData={dataToExport}
        msmePaymentDetailsData={msmePaymentDetailsData}
      />
    </>
  );
};

export default TabPaymentDetailMSMEApplicationListingWrapper;
